import {
  fetchListPayoutWallet,
  fetchPayoutWallet,
  postNewPayoutWallet,
  deletePayoutWallet,
  updatePayoutWallet,
  resendConfirmationPayout
} from "@/api/wallet";

const state = {
  adaWallets: [],
  btcWallets: [],
  ethWallets: [],
  xlmWallets: [],
  xrpWallets: []
};

const mutations = {
  UPDATE_ADA_WALLETS(state, payload) {
    state.adaWallets = payload;
  },
  UPDATE_BTC_WALLETS(state, payload) {
    state.btcWallets = payload;
  },
  UPDATE_ETH_WALLETS(state, payload) {
    state.ethWallets = payload;
  },
  UPDATE_XLM_WALLETS(state, payload) {
    state.xlmWallets = payload;
  },
  UPDATE_XRP_WALLETS(state, payload) {
    state.xrpWallets = payload;
  }
};

const actions = {
  fetchListPayoutWallet({ commit }, { query, coin }) {
    return new Promise((resolve, reject) => {
      fetchListPayoutWallet(query, coin)
        .then(response => {
          commit(`UPDATE_${coin}_WALLETS`, response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchPayoutWallet({ commit }, id) {
    return new Promise((resolve, reject) => {
      fetchPayoutWallet(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  resendConfirmationPayout({ commit }, { id, coin }) {
    return new Promise((resolve, reject) => {
      resendConfirmationPayout(id, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deletePayoutWallet({ commit }, { id, coin }) {
    return new Promise((resolve, reject) => {
      deletePayoutWallet(id, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updatePayoutWallet({ commit }, { data, coin }) {
    return new Promise((resolve, reject) => {
      updatePayoutWallet(data, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postNewPayoutWallet({ commit }, { data, coin }) {
    return new Promise((resolve, reject) => {
      postNewPayoutWallet(data, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const wallet = {
  state,
  mutations,
  actions,
  getters: {
    adaWallets: state => state.adaWallets,
    btcWallets: state => state.btcWallets,
    ethWallets: state => state.ethWallets,
    xlmWallets: state => state.xlmWallets,
    xrpWallets: state => state.xrpWallets,
    getWalletsByCoin: state => coin => {
      switch (coin) {
        case "BTC":
          return state.btcWallets;
        case "ETH":
          return state.ethWallets;
        case "ADA":
          return state.adaWallets;
        case "XLM":
          return state.xlmWallets;
        case "XRP":
          return state.xrpWallets;
        default:
          return [];
      }
    }
  }
};

export default wallet;
